<template>
  <div id="app" class="app-root">
    <router-view />
  </div>
</template>

<script>
import { getRefreshToken } from '@/utils/auth';
import { scheduleNextProactiveRefresh } from '@/utils/request';

export default {
  name: 'App',
  created() {
    this.$store.dispatch('loadPlatformConfig');
    if (getRefreshToken()) {
      scheduleNextProactiveRefresh();
    }
  }
};
</script>

<style lang="less">
html,
body,
#app,
.app-root {
  height: 100%;
  margin: 0;
}
</style>
